import * as amplitude from "@amplitude/analytics-browser"
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser"

export default defineNuxtPlugin(({ $config }) => {
	if (!$config.public.amplitudeApiKey) return

	amplitude.init($config.public.amplitudeApiKey, {
		serverZone: "EU",
		serverUrl: "/amplitude",
		autocapture: {
			elementInteractions: true
		}
	})

	const sessionReplayTracking = sessionReplayPlugin({
		sampleRate: Number($config.public.amplitudeSampleRate) || 0
	})

	amplitude.add(sessionReplayTracking)
})
